// https://github.com/software-mansion/react-native-reanimated/issues/1423#issuecomment-729617103
(window as any).__reanimatedWorkletInit =
  (window as any).__reanimatedWorkletInit ?? (() => {});
